export default __webpack_public_path__ + "static/media/vpn-background-1.917463a4.png";